import { Box, Paper, Typography } from "@mui/material";
import type { CobblesSummary } from "../models/CobblesReport";

const formatDuration = (totalSeconds: number): string => {
	const s = Math.max(0, Math.floor(totalSeconds || 0));
	const h = Math.floor(s / 3600);
	const m = Math.floor((s % 3600) / 60);
	const sec = s % 60;
	return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}:${String(sec).padStart(2, "0")}`;
};

interface Props {
	summary: CobblesSummary | null;
}

export const CobblesSummaryBand = ({ summary }: Props) => {
	const count = summary?.count ?? 0;
	const duration = formatDuration(summary?.durationSeconds ?? 0);

	return (
		<Paper elevation={1} sx={{ px: 2, py: 0.75 }}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					gap: 4,
					flexWrap: "wrap",
				}}
			>
				<Typography variant="body2">
					<strong>Count:</strong> {count}
				</Typography>
				<Typography variant="body2">
					<strong>Estimated stop time due to cobbles:</strong> {duration}
				</Typography>
			</Box>
		</Paper>
	);
};
